import { BoardPostDetail, BoardPostDetailResponse } from '@/types/community';
import { displayedAt } from '@/utils/format';

export class BoardPostDetailService {
  static boardPostDetailParser = (
    data?: BoardPostDetailResponse,
  ): BoardPostDetail => {
    if (!data) return {} as BoardPostDetail;
    return {
      ...data,
      formattedCreatedAt: displayedAt(data.createdAt),
      boardComments: data.boardComments.map((comment) => {
        return {
          ...comment,
          formattedCreatedAt: displayedAt(comment.createdAt),
        };
      }),
    };
  };
}
